import { getCookie } from 'nove8/helpers/getCookie'

export const getFacebookParams = (): { fbp: string; fbc: string } => {
  const fbp = getCookie('_fbp')
  const fbc = getCookie('_fbc')
  const creationTime = new Date().getTime()
  const randomNumber = Math.floor(Math.random() * 1e10)
  const urlParams = new URLSearchParams(window.location.search)
  const fbclid = urlParams.get('fbclid')

  const formattedFbc = !fbc && fbclid ? `fb.1.${creationTime}.${fbclid}` : fbc
  const formattedFbp = !fbp ? `fb.1.${creationTime}.${randomNumber}` : fbp

  return {
    fbp: formattedFbp,
    fbc: formattedFbc,
  }
}
